import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { type HeroBannerDestinationValues } from 'domains/merchandising/types/heroBanner.types'
import { useDashMessages } from 'intl/intl.hooks'

interface FieldProps {
  destination: HeroBannerDestinationValues
}

export const HeroBannerDetailsLinkDestination: FunctionComponent<FieldProps> = ({
  destination,
}) => {
  const messages = useDashMessages({
    emptyValue: 'merchandising.hero-banners.field.empty.value',
    destinationTypeLabel:
      'merchandising.hero-banners.section.link-destination.field.destinationType.label',
  })

  const destinationText = destination?.target
    ? `${destination.displayValue} (${destination.type})`
    : messages.emptyValue

  return (
    <MerchandisingFormSection titleId="merchandising.hero-banners.section.link-destination.title">
      <Text weight="semibold">{messages.destinationTypeLabel}</Text>
      <Text size="medium">{destinationText}</Text>
    </MerchandisingFormSection>
  )
}
